import {
  CrownOutlined,
  GiftOutlined,
  NotificationOutlined,
  TeamOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { UserRole } from '@mm/state/model/CompanyUsersModel';
import { ReactComponent as BusinessIcon } from 'assets/business.svg';
import React, { ReactNode } from 'react';
import { SettingsRoutes } from '../../../../routes/settings-routes';
import {
  AFFILIATES,
  BILLING,
  USERS,
  COMPANY,
  MY_ACCOUNT,
  NOTIFICATIONS,
} from '../constants';

export type SidebarPage = {
  path: string;
  name: string;
  id: string;
  matchPattern: RegExp;
  requiresAdminPermission: boolean;
  hiddenToRoles?: string[];
  icon: ReactNode;
  helpLink?: string;
};

export const sidebarPages: SidebarPage[] = [
  {
    path: SettingsRoutes.myAccount.path,
    name: MY_ACCOUNT,
    id: SettingsRoutes.myAccount.path,
    matchPattern: /my-account/,
    requiresAdminPermission: false,
    icon: <UserOutlined />,
  },
  {
    path: SettingsRoutes.company.path,
    name: COMPANY,
    id: SettingsRoutes.company.path,
    matchPattern: /company/,
    requiresAdminPermission: true,
    hiddenToRoles: [UserRole.LiveChatAgent, UserRole.MonitorLeads],
    icon: <BusinessIcon />,
  },
  {
    path: SettingsRoutes.billing.path,
    name: BILLING,
    id: SettingsRoutes.billing.path,
    matchPattern: /billing/,
    requiresAdminPermission: true,
    hiddenToRoles: [UserRole.LiveChatAgent, UserRole.MonitorLeads],
    icon: <CrownOutlined />,
    helpLink: 'https://customers.ai/pricing',
  },
  {
    path: SettingsRoutes.users.path,
    name: USERS,
    id: SettingsRoutes.users.path,
    matchPattern: /users/,
    requiresAdminPermission: true,
    hiddenToRoles: [UserRole.LiveChatAgent, UserRole.MonitorLeads],
    icon: <TeamOutlined />,
    helpLink:
      'https://customers.ai/help/l/en/article/0jc3efvcxy-how-do-i-add-a-user',
  },
  {
    path: SettingsRoutes.affiliates.path,
    name: AFFILIATES,
    id: SettingsRoutes.affiliates.path,
    matchPattern: /referrals/,
    requiresAdminPermission: false,
    hiddenToRoles: [UserRole.LiveChatAgent, UserRole.MonitorLeads],
    icon: <GiftOutlined />,
  },
  {
    path: SettingsRoutes.notifications.path,
    name: NOTIFICATIONS,
    id: SettingsRoutes.notifications.path,
    matchPattern: /notifications/,
    requiresAdminPermission: false,
    hiddenToRoles: [UserRole.MonitorLeads],
    icon: <NotificationOutlined />,
    helpLink:
      'https://customers.ai/help/l/en/article/ptx8i6csuz-mobile-monkey-push-notification',
  },
];
